var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuVideo = function SvgMenuVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.354 13C1.354 6.568 6.568 1.354 13 1.354S24.646 6.568 24.646 13 19.432 24.646 13 24.646 1.354 19.432 1.354 13",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#menu-video_svg__a)",
    fillRule: "evenodd",
    d: "M13.05 8.244c.507.25 1.124.63 1.88 1.094l.07.044c.757.465 1.373.845 1.83 1.188.463.35.865.735 1.08 1.252a3.07 3.07 0 0 1 0 2.356c-.215.517-.617.902-1.08 1.252-.457.343-1.073.723-1.83 1.188l-.07.044c-.756.465-1.373.844-1.88 1.094-.512.251-1.044.44-1.603.378a2.79 2.79 0 0 1-1.987-1.215c-.312-.458-.421-1.013-.472-1.603-.05-.589-.05-1.343-.05-2.277v-.078c0-.934 0-1.688.05-2.277s.16-1.145.472-1.603a2.79 2.79 0 0 1 1.987-1.215c.56-.062 1.091.127 1.602.378m-1.423 1.237c.085-.01.269.007.705.221.43.212.981.55 1.782 1.042.8.493 1.35.832 1.738 1.125.388.292.511.464.56.579.145.35.145.754 0 1.104-.049.115-.172.287-.56.58-.388.292-.939.631-1.738 1.124-.8.492-1.351.83-1.782 1.042-.436.214-.62.23-.705.22a1.16 1.16 0 0 1-.825-.515c-.069-.101-.15-.31-.195-.826-.044-.51-.044-1.195-.044-2.177s0-1.666.044-2.177c.045-.516.126-.725.196-.826.205-.302.509-.48.824-.516",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "menu-video_svg__a",
    x1: 13.619,
    x2: 27.705,
    y1: 20.338,
    y2: 7.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))));
};
export { SvgMenuVideo as ReactComponent };